<template>
    <div>
        <button :aria-expanded="this.isOpen"
                :aria-controls="`collapse${this._uid}`"
                @click="toggleAccordion()"
                class="w-full flex justify-between items-center relative">

            <!-- title of the accordion -->
            <slot name="title" />

            <svg :class="['h-2 absolute top-[7px] right-0 transition-all duration-200 transform', {'rotate-180': this.isOpen, 'rotate-0': !this.isOpen, }]"
                 fill="none"
                 stroke="currentColor"
                 xmlns="http://www.w3.org/2000/svg"
                 viewBox="0 0 16 10"
                 aria-hidden="true">
                <path d="M15 1.2l-7 7-7-7" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
        </button>

        <div v-show="this.isOpen" :id="`collapse${this._uid}`">
            <slot name="content" />
        </div>
    </div>
</template>

<script type="text/javascript">

// TODO: Implement closing neighbours
export default
{
    name: "Accordion",

    /**
     * Accordion Props
     */
    props:{
        open: {
            Type: Boolean,
        }
    },

    /**
     * Accordion Data
     * @return {{isOpen: boolean}}
     */
    data()
    {
        return {
            isOpen: this.open,
        };
    },

    methods: {

        /**
         * Toggle Accordion Item
         * @return {boolean}
         */
        toggleAccordion()
        {
            this.isOpen = !this.isOpen;
        },
    },
};
</script>
